import {
  useGetCurrentUserQuery,
  useGetSessionsAnalyticsActivityQuery,
} from '@carboncopyco/data';
import type { ResourceType } from '@carboncopyco/types';
import { useParams } from 'react-router-dom';
import { AnalyticsCard } from './AnalyticsCard';
import { useConsoleState } from './ConsoleContext';
import { useGetAnalyticsCardCommonData } from './useGetAnalyticsCardCommonData';

export const DemoAnalyticsCard = () => {
  const { organizationId, workspaceId } = useParams();
  const { timezone, endTime, startTime } = useConsoleState();
  const { data: userData } = useGetCurrentUserQuery();
  const resourceTypes: ResourceType[] = ['managed_presentation', 'play'];

  const {
    trend,
    chart,
    isLoading: isLoadingCommon,
  } = useGetAnalyticsCardCommonData({
    resourceTypes,
  });

  const {
    data: { results: totalActivityResults } = {},
    isLoading: isLoadingTotal,
  } = useGetSessionsAnalyticsActivityQuery({
    organizationId,
    resourceTypes,
    workspaceIds: [workspaceId],
    start: startTime,
    end: endTime,
    timezone,
    resolution: 'summary',
    shortSessions: true,
    internalSessions: true,
  });

  const { data: myActivityData, isLoading: isLoadingMyTotal } =
    useGetSessionsAnalyticsActivityQuery(
      {
        organizationId,
        resourceTypes,
        workspaceIds: [workspaceId],
        start: startTime,
        end: endTime,
        timezone,
        resolution: 'summary',
        shortSessions: true,
        internalSessions: true,
        userId: userData.user.email,
      },
      {
        skip: !userData?.user?.email,
      }
    );

  const breakdownLabel = myActivityData?.results
    ? `${myActivityData?.results?.[0]?.values.occurrences || 0} Given by me`
    : '';
  const isLoading = isLoadingTotal || isLoadingCommon || isLoadingMyTotal;

  return (
    <AnalyticsCard
      title="Demos given"
      chart={chart}
      isLoading={isLoading}
      total={totalActivityResults?.[0]?.values?.occurrences}
      breakdown={breakdownLabel}
      trend={trend}
    />
  );
};
